import {
  WSButton,
  WSContainer,
  WSElement,
  WSFlexBox,
  WSIcon,
  WSMessageBox,
  WSMessageBoxProps,
  WSScreen
} from "@wingspanhq/fe-component-library";
import * as React from "react";
import { ResponsiveWingspanLogo } from "../../../components/ResponsiveWingspanLogo/ResponsiveWingspanLogo";
import { AskYourAdvocateButton } from "../AskYourAdvocateWidget/AskYourAdvocateWidget";
import styles from "./OnboardingHeader.module.scss";

interface OnboardingHeaderProps {
  onBack?: () => void;
  bannerText?: React.ReactNode;
  bannerProps?: WSMessageBoxProps;
}

export const OnboardingHeader: React.FC<OnboardingHeaderProps> = ({
  onBack,
  bannerText,
  bannerProps
}) => {
  if (!bannerText) {
    bannerText = " ";
  }
  return (
    <>
      <WSScreen.TabletAndDesktop>
        <WSContainer>
          <WSElement className={styles.desktopHeader}>
            {onBack ? (
              <WSIcon name="back" onClick={onBack} color="grey700" />
            ) : (
              <WSElement />
            )}
            <a href="https://wingspan.app" className={styles.logoLink}>
              <ResponsiveWingspanLogo />
            </a>
            <AskYourAdvocateButton />
          </WSElement>
        </WSContainer>
      </WSScreen.TabletAndDesktop>
      <WSScreen.Mobile>
        <WSFlexBox
          p="M"
          justify="space-between"
          wrap="nowrap"
          alignItems="center"
        >
          <a href="https://wingspan.app">
            <ResponsiveWingspanLogo />
          </a>
          <AskYourAdvocateButton />
        </WSFlexBox>
      </WSScreen.Mobile>

      {bannerText && (
        <WSMessageBox
          kind="Warning"
          noBorder
          centered
          className={styles.banner}
          {...bannerProps}
        >
          {bannerText}
        </WSMessageBox>
      )}

      {onBack && (
        <WSScreen.Mobile>
          <WSContainer>
            <WSButton.Link
              icon="chevronLeft"
              color="grey700"
              onClick={onBack}
              mt="L"
            >
              Back
            </WSButton.Link>
          </WSContainer>
        </WSScreen.Mobile>
      )}
    </>
  );
};
